import { inject, ProviderToken } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { OpenDetailTabsService } from './open-detail-tabs.service';

/** Route guard asking before unsaved changes held by the tabs of the given service get lost. */
export function confirmDiscardDetailTabs(service: ProviderToken<OpenDetailTabsService>): CanDeactivateFn<unknown> {
    return () => inject(service).confirmDiscard();
}
